export default "__VITE_ASSET__5fd16b71__"